
(function(){
  var LAB_LOGOS = {
    gia: 'https://cdn.shopify.com/s/files/1/0757/8851/7659/files/GIA_Icon_60d07140-6c0d-4f9d-8321-89b0bd69240a.png?v=1684576576',
    igi: 'https://cdn.shopify.com/s/files/1/0411/6437/4183/files/IGI_Icon_d7510f13-1b92-4a59-9ae5-4bf69426e48d.png?v=1680007037'
  };
  // Hardcoded liquid placeholder we must NOT mistake for real data
  var PLACEHOLDER_CERT_NO = '2486697056';

  function buildVerifyUrl(labKey, reportNumber) {
    if (!reportNumber) return null;
    var n = String(reportNumber).replace(/\s+/g, '');
    if (labKey === 'gia') {
      return 'https://www.gia.edu/report-check?locale=en_US&reportno=' + encodeURIComponent(n);
    }
    if (labKey === 'igi') {
      return 'https://www.igi.org/verify.php?r=' + encodeURIComponent(n);
    }
    return null;
  }

  // Pull cert info from MULTIPLE sources with fallbacks. Not every diamond
  // populates the accordion rows, so we also check the short-info panel
  // and the thumbnail's certificate link.
  function collectCertInfo(container) {
    var certLab = '', certNumber = '';

    // Source A: Short-info panel (populated early and reliably)
    var shortCert = container.querySelector('.certificate-type-info');
    if (shortCert) {
      var t = (shortCert.textContent || '').trim();
      if (t && t.toUpperCase() !== 'GIA' || t) certLab = t;
    }

    // Source B: Accordion rows (Lab / Certificate Number)
    var pairContainer = container.querySelector('.product_description--accordion .pair-first-diamond');
    if (pairContainer) {
      pairContainer.querySelectorAll('p').forEach(function(p) {
        var lbl = p.querySelector('.meta__title');
        var val = p.querySelector('.meta-info-desc');
        if (!lbl || !val) return;
        var k = lbl.textContent.trim().toLowerCase();
        var txt = (val.textContent || '').trim();
        if (!txt) return;
        if (!certLab && (k === 'lab' || k === 'laboratory')) certLab = txt;
        else if (!certNumber && (k === 'certificate number' || k === 'cert number' || k === 'certificate' || k === 'report number')) certNumber = txt;
      });
    }

    // Source C: Thumbnail certificate link — parse URL for lab + report #
    var thumbLink = container.querySelector('.diamond-thumbnil.diamond-certificate a[href]');
    if (thumbLink) {
      var href = thumbLink.getAttribute('href') || '';
      if (!certNumber) {
        var m = href.match(/reportno=([^&]+)/i) || href.match(/[?&]r=([^&]+)/i);
        if (m) certNumber = decodeURIComponent(m[1]);
      }
      if (!certLab) {
        if (href.indexOf('gia.edu') > -1) certLab = 'GIA';
        else if (href.indexOf('igi.org') > -1) certLab = 'IGI';
      }
    }

    // Ignore the hardcoded placeholder
    if (certNumber === PLACEHOLDER_CERT_NO) certNumber = '';

    return { lab: certLab, number: certNumber };
  }

  // 2026-05-21: track the last-built spec signature so we can detect when the
  // accordion data has changed (diamonddetail.js replaces it after the API
  // response). If signature differs from the existing .sp-stone-spec, we
  // rebuild instead of bailing — fixes the bug where the spec block kept
  // showing the placeholder / previous SKU's data after navigation.
  function specSignature(pairContainer) {
    var rows = pairContainer.querySelectorAll('p');
    var sig = '';
    rows.forEach(function(p) {
      var l = p.querySelector('.meta__title');
      var v = p.querySelector('.meta-info-desc');
      sig += (l ? l.textContent.trim() : '') + '=' + (v ? v.textContent.trim() : '') + '|';
    });
    return sig;
  }

  function buildStoneSpec() {
    var container = document.querySelector('.diamond-product-template');
    if (!container) return false;
    var pairContainer = container.querySelector('.product_description--accordion .pair-first-diamond');
    if (!pairContainer) return false;
    var rows = pairContainer.querySelectorAll('p');
    if (!rows || rows.length < 3) return false;

    var sig = specSignature(pairContainer);
    // 2026-05-21: render as an accordion item INSIDE
    // .product_description--accordion (appended after Lifetime Diamond
    // Upgrade), not as a standalone block at the end of the page.
    var accordion = container.querySelector('.product_description--accordion');
    if (!accordion) return false;
    var existingHeader = accordion.querySelector('.accordion-header.sp-stone-spec-h');
    if (existingHeader && existingHeader.getAttribute('data-sig') === sig) return true;
    // Also remove any leftover standalone block from prior versions
    var oldStandalone = container.querySelector('.sp-stone-spec');
    if (oldStandalone && oldStandalone.parentNode) oldStandalone.parentNode.removeChild(oldStandalone);

    var specs = {};
    rows.forEach(function(p) {
      var labelEl = p.querySelector('.meta__title');
      var valueEl = p.querySelector('.meta-info-desc');
      if (!labelEl || !valueEl) return;
      var key = labelEl.textContent.trim().toLowerCase();
      var html = valueEl.innerHTML.trim();
      var textOnly = valueEl.textContent.trim();
      specs[key] = { label: labelEl.textContent.trim(), html: html, text: textOnly };
      // 2026-05-21: index a few alias keys so the L/W Ratio lookup survives
      // label variants like "L/W Ratio", "L/W RATIO", "LW Ratio", "Ratio".
      var k = key.replace(/[\s\.]+/g, '');                 // "l/wratio"
      if (k === 'l/wratio' || k === 'lwratio' || k === 'ratio'
          || k === 'length/widthratio' || k === 'lengthwidthratio') {
        specs['l/w ratio'] = specs[key];
      }
      if (key === 'mm' || key === 'dimension' || key === 'dimensions') {
        specs['measurement'] = specs[key];
      }
    });

    // Format measurement value nicely: "6.02x4.23x2.38" → "6.02 × 4.23 × 2.38 mm"
    if (specs['measurement'] && specs['measurement'].text) {
      var t = specs['measurement'].text.trim();
      if (/^\d/.test(t) && /x/i.test(t) && !/×/.test(t)) {
        var pretty = t.replace(/\s*x\s*/gi, ' × ');
        if (!/mm$/i.test(pretty)) pretty += ' mm';
        specs['measurement'].html = pretty;
        specs['measurement'].text = pretty;
      }
    }

    // Rewrite Lab / Certificate links to our proper verify URLs
    var cert = collectCertInfo(container);
    var labKeyHere = (cert.lab || '').toLowerCase().indexOf('igi') > -1 ? 'igi'
                   : (cert.lab || '').toLowerCase().indexOf('gia') > -1 ? 'gia'
                   : null;
    var verifyHere = buildVerifyUrl(labKeyHere, cert.number);
    if (verifyHere) {
      if (specs['lab']) specs['lab'].html = '<a href="' + verifyHere + '" target="_blank" rel="noopener">' + cert.lab + '</a>';
      if (specs['certificate number']) specs['certificate number'].html = '<a href="' + verifyHere + '" target="_blank" rel="noopener">' + cert.number + '</a>';
    }

    var groups = [
      { title: "The Four C's", keys: ['cut', 'carat', 'color', 'clarity'] },
      { title: 'Measurements',  keys: ['shape', 'l/w ratio', 'measurement', 'table', 'depth'] },
      { title: 'Finish & Fluorescence', keys: ['polish', 'symmetry', 'fluorescence'] }
    ];

    // Build accordion-header (matches existing accordion items so the theme's
    // toggle JS picks it up automatically) + accordion-content.
    // Use h3.ac-h3 to match the other accordion headers (DIAMOND DETAILS /
    // PRICE GUARANTEE / LIFETIME UPGRADE all render that way at runtime).
    var headerHtml = '<div class="accordion-header sp-stone-spec-h" data-sig="' + sig.replace(/"/g, '&quot;') + '">'
                   +   '<h3 class="ac-h3">DIAMOND SPECIFICATIONS</h3>'
                   +   '<span class="arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-down" viewBox="0 0 9 9"><path d="M8.542 2.558a.625.625 0 0 1 0 .884l-3.6 3.6a.626.626 0 0 1-.884 0l-3.6-3.6a.625.625 0 1 1 .884-.884L4.5 5.716l3.158-3.158a.625.625 0 0 1 .884 0z" fill="#fff"></path></svg></span>'
                   + '</div>';

    var contentHtml = '<div class="accordion-content sp-stone-spec-c" style="display: none;">'
                    +   '<div class="sp-stone-spec__inner">';
    groups.forEach(function(g) {
      contentHtml += '<div class="sp-stone-spec__group">';
      contentHtml +=   '<div class="sp-stone-spec__title">' + g.title + '</div>';
      contentHtml +=   '<div class="sp-stone-spec__rows">';
      g.keys.forEach(function(k) {
        var s = specs[k];
        if (!s) return;
        var plain = (s.text || '').replace(/<[^>]+>/g, '').trim();
        if (!plain || plain === '—' || plain === '-' || plain === 'N/A' || plain === 'n/a') return;
        var longRow = (k === 'measurement' || k === 'certificate number' || plain.length > 12);
        contentHtml += '<div class="sp-stone-spec__row' + (longRow ? ' sp-stone-spec__row--long' : '') + '">';
        contentHtml +=   '<span class="sp-stone-spec__label">' + s.label + '</span>';
        contentHtml +=   '<span class="sp-stone-spec__value">' + s.html + '</span>';
        contentHtml += '</div>';
      });
      contentHtml +=   '</div>';
      contentHtml += '</div>';
    });
    contentHtml +=   '</div>';
    contentHtml += '</div>';

    // Remove any previously-built version, then append at end of accordion list
    // (which puts it AFTER Lifetime Diamond Upgrade).
    var prevHeader  = accordion.querySelector('.accordion-header.sp-stone-spec-h');
    var prevContent = accordion.querySelector('.accordion-content.sp-stone-spec-c');
    if (prevHeader)  prevHeader.parentNode.removeChild(prevHeader);
    if (prevContent) prevContent.parentNode.removeChild(prevContent);
    accordion.insertAdjacentHTML('beforeend', headerHtml + contentHtml);
    return true;
  }

  function buildCertStamp() {
    var container = document.querySelector('.diamond-product-template');
    if (!container) return false;
    if (container.querySelector('.sp-stone-cert-stamp')) return true;

    var cert = collectCertInfo(container);
    if (!cert.lab && !cert.number) return false; // nothing to show yet — retry

    var labKey = (cert.lab || '').toLowerCase().indexOf('igi') > -1 ? 'igi'
               : (cert.lab || '').toLowerCase().indexOf('gia') > -1 ? 'gia'
               : null;
    var logoSrc = labKey ? LAB_LOGOS[labKey] : null;
    var certLink = buildVerifyUrl(labKey, cert.number);

    var accordion = container.querySelector('.product_description--accordion');
    if (!accordion) return false;

    var logoHtml = logoSrc
      ? '<img src="' + logoSrc + '" alt="' + cert.lab + '" loading="lazy">'
      : '<svg viewBox="0 0 24 24" fill="none" stroke="#8B7355" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" width="18" height="18"><path d="M12 2l3 6 7 1-5 5 1 7-6-3-6 3 1-7-5-5 7-1z"/></svg>';

    var stampHtml = '<div class="sp-stone-cert-stamp">';
    stampHtml +=      '<div class="sp-stone-cert-stamp__logo">' + logoHtml + '</div>';
    stampHtml +=      '<div class="sp-stone-cert-stamp__body">';
    stampHtml +=        '<span class="sp-stone-cert-stamp__lab">' + (cert.lab || 'Certified') + ' Certified</span>';
    if (cert.number) stampHtml += '<span class="sp-stone-cert-stamp__number">Report #' + cert.number + '</span>';
    stampHtml +=      '</div>';
    if (certLink) {
      stampHtml +=    '<a class="sp-stone-cert-stamp__link" href="' + certLink + '" target="_blank" rel="noopener">View</a>';
    }
    stampHtml +=    '</div>';

    accordion.insertAdjacentHTML('beforeend', stampHtml);
    return true;
  }

  document.addEventListener('DOMContentLoaded', function() {
    var tries = 0;
    // 2026-05-21: poll for up to 30 seconds. Both builders are idempotent —
    // they check the data signature and rebuild only when accordion content
    // changes (e.g. when diamonddetail.js replaces the placeholder with the
    // real API response). Don't bail early; keep polling so we catch the
    // late API-arrival update.
    var iv = setInterval(function() {
      tries++;
      buildStoneSpec();
      buildCertStamp();
      if (tries > 120) clearInterval(iv);
    }, 250);

    function syncAccordionStates() {
      document.querySelectorAll('.diamond-product-template .accordion-header').forEach(function(h) {
        if (h._spBound) return;
        h._spBound = true;
        h.addEventListener('click', function() {
          setTimeout(function() {
            var next = h.nextElementSibling;
            var openNow = next && getComputedStyle(next).display !== 'none';
            h.classList.toggle('active', openNow);
          }, 10);
        });
        var next = h.nextElementSibling;
        var openNow = next && getComputedStyle(next).display !== 'none';
        h.classList.toggle('active', openNow);
      });
    }
    syncAccordionStates();
    setTimeout(syncAccordionStates, 1500);
    setTimeout(syncAccordionStates, 3000);
  });
})();
